var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeasurement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-14 -343) translate(14 343)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 1.125
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V6H0z",
    transform: "translate(-14 -343) translate(14 343) rotate(-45 20.364 1.464)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M12 3L12 6M8 3L8 6M4 3L4 6M10 4L10 6M6 4L6 6M2 4L2 6",
    transform: "translate(-14 -343) translate(14 343) rotate(-45 20.364 1.464)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurement);
export default __webpack_public_path__ + "static/media/measurement.4eff8d1b46b493ec43a7efdf86d89cc0.svg";
export { ForwardRef as ReactComponent };